import React from "react";
import styles from "./HistoryTabs.module.scss";

interface HistoryTabsProps {
  activeTab: 'upcoming' | 'completed';
  onTabChange: (tab: 'upcoming' | 'completed') => void;
}

export const HistoryTabs: React.FC<HistoryTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <ul className={styles.tabList}>
      <li 
        className={`${styles.tabTitle} ${activeTab === 'upcoming' ? styles.tabActive : ''}`}
        onClick={() => onTabChange('upcoming')}
      >
        Предстоящее
      </li>
      <li 
        className={`${styles.tabTitle} ${activeTab === 'completed' ? styles.tabActive : ''}`}
        onClick={() => onTabChange('completed')}
      >
        Завершенное
      </li>
    </ul>
  );
};
